module.exports = __webpack_public_path__ + "static/media/clock.9ced877b.svg";